import {defineMessages} from 'react-intl';

export default defineMessages({
	passwordsIsNotMatchedError: {
		id: 'forms.fields.password.error.notMatched',
		defaultMessage: 'Passwords do not match'
	},
	passwordSpecialCharsMinLength: {
		id: 'forms.fields.password.error.specialCharsMinLength',
		defaultMessage: 'Password should have at least {minSpecialChars} special symbols'
	},
	passwordErrorLetters: {
		id: 'forms.fields.password.error.letters',
		defaultMessage: 'Password must have letters'
	},
	passwordErrorMixedLetters: {
		id: 'forms.fields.password.error.mixedLetters',
		defaultMessage: 'Password must have uppercase and lowercase letters '
	},
	passwordErrorNumbers: {
		id: 'forms.fields.password.error.numbers',
		defaultMessage: 'Password must have numbers '
	},
	passwordErrorLength: {
		id: 'forms.fields.password.error.length',
		defaultMessage: 'Password should have from {minLength} to {maxLength} symbols'
	},
	passwordErrorGeneral: {
		id: 'forms.fields.password.error.general',
		defaultMessage: 'Password error'
	},
});
